module.exports = __webpack_public_path__ + "img/img15.7384f6d8.svg";